<script>
    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import { fly, fade, slide } from 'svelte/transition';

    import { config } from '../config.js';
    import { vptServer, token, userName, staffUrn } from '../stores.js';
    
    import ContactForm from './ContactForm.svelte';
    
    const dispatch = createEventDispatcher();

    export let inmateUrn;
    export let inmateName;
    export let unseenDays;
    export let headerText = "";

    let image;
    let contactDate;
    let contactTime;
    let contactNotes;
    let seenBy;
    let followUp = true;
    let followUpDate;
    let followUpAction;
    let isFormValid;
    let showValidation = false;
    
    // Prevent double click when saving
    let isSaving = false;

    onMount(() => {
        seenBy = $staffUrn;
        getPrimaryImage();
    });

    async function getPrimaryImage() {
        await fetch(`${$vptServer}/inmate/${inmateUrn}/image`, {
            headers: {
                "Authorization": "Bearer " + $token
            }
        })
        .then(r => {
            if (!r.ok) {
                throw Error(r.status);
            }
            return r;
        })
        .then(r => r.json())
        .then(data => {
            if (data.image) {
                image = data.image;
            }
        })
        .catch(error => {
            console.error(error);
            return;
        });
    }

    function add() {
        isSaving = true;
        if (isFormValid) { 
            addContact();
        } else {
            showValidation = true;
            isSaving = false;
        }
    }

    async function addContact() {
        await fetch(`${$vptServer}/inmate/${inmateUrn}/contact/insert`, {
            headers: {
                "Authorization": "Bearer " + $token,
                "Content-Type": "application/json"
            },
            method: 'POST',
            body: JSON.stringify({
                typeId: $config.contactTypeId,
                contactDateTime: contactDate + " " + contactTime,
                notes: contactNotes,
                actionDueDate: followUp ? followUpDate : undefined,
                actionNotes: followUp ? followUpAction : undefined,
                userId: $userName,
                staffId: seenBy
            })
        })
        .then(r => {
            if (!r.ok) {
                throw Error(r.status);
            }
            dispatch('close', {refresh: true});
            return r;
        })
        .catch(error => {
            console.error(error);
            return;
        });
    }
    
    function closeModal() {
        dispatch('close', {refresh: false});
    }
</script>

<style>
    .modal-alert-danger span:last-of-type {
        margin-left: 6px;
    }
</style>

<div class="modal" tabindex="-1" role="dialog" aria-label="Contact">
    <div in:fly={{ y: -100 }} class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header" class:img={image && !headerText}>
                {#if headerText}
                    <h5 class="modal-title">{headerText}</h5>
                {:else}
                    {#if image}
                        <img in:fade={{ duration: 300 }} id="inmate-image" src="data:image/jpg;base64,{image}" alt="inmate" />
                    {/if}
                    <div class="modal-title">
                        <h5>Contact</h5>
                        <span>{inmateName.toUpperCase()}</span>
                    </div>
                {/if}
                <button type="button" class="close" aria-label="Close" on:click={closeModal}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            {#if unseenDays && unseenDays > 0}
                 <div class="modal-alert modal-alert-header modal-alert-danger">
                    <span class="icon"><i class="bi bi-exclamation-triangle" /></span>
                    <span>{$config.inmateLabelName} has been targeted for {unseenDays} day{unseenDays == 1 ? '' : 's'} but no contact has been recorded.</span>
                </div>
            {/if}

            <div class="modal-body">
                <ContactForm bind:contactDate bind:contactTime bind:contactNotes bind:seenBy
                    bind:followUp bind:followUpDate bind:followUpAction bind:isFormValid bind:showValidation />
            </div>

            {#if followUp}
                <div transition:slide|local={{ duration : 400 }} class="modal-alert modal-alert-footer">
                    <span class="icon"><i class="bi bi-info-circle" /></span>
                    <span>Consider the ACCT process if the {$config.inmateLabelName} is at risk.</span>
                </div>
            {/if}
            
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" disabled={isSaving} 
                    on:click={() => add()}>Add Contact</button>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop show"></div>
